import React, { useState } from "react";
import { toast } from "../hooks/use-toast";
import { Heart, ArrowUpRight } from "lucide-react";

const amounts = [25, 50, 100, 250, 500, 1000];

const Donate = () => {
  const [amt, setAmt] = useState(100);
  const [custom, setCustom] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const submit = (e) => { e.preventDefault(); toast({ title: 'Thank you!', description: `Your $${custom || amt} contribution moves us forward.` }); setName(''); setEmail(''); setCustom(''); };

  return (
    <div>
      <section className="max-w-[1100px] mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="section-eyebrow text-[#0d2a20]/60 mb-6">Donate</div>
        <h1 className="hero-title text-[52px] md:text-[96px] leading-[0.95]">Fund the <span className="font-serif-i text-[#e0684d]">future</span>.</h1>
        <p className="mt-8 max-w-[720px] text-[17px] leading-relaxed text-[#0d2a20]/80">100% of your contribution goes directly to expanding capacity for Nigerian organisations building tomorrow&rsquo;s workforce.</p>
      </section>

      <section className="max-w-[1100px] mx-auto px-6 lg:px-10 pb-24">
        <form onSubmit={submit} className="rounded-lg p-8 md:p-10 space-y-6" style={{ background: '#fbf8ef' }}>
          <div>
            <label className="text-[12px] text-[#0d2a20]/70">Choose an amount (USD)</label>
            <div className="grid grid-cols-3 md:grid-cols-6 gap-2 mt-2">
              {amounts.map(a => (
                <button type="button" key={a} onClick={() => { setAmt(a); setCustom(''); }} className={`py-3 rounded-md text-[15px] ${amt === a && !custom ? 'bg-[#0f3d2e] text-[#f4efe4]' : 'bg-white border'}`} style={amt !== a || custom ? { borderColor: 'rgba(13,42,32,0.15)' } : {}}>${a}</button>
              ))}
            </div>
          </div>
          <div>
            <label className="text-[12px] text-[#0d2a20]/70">Or enter a custom amount</label>
            <input value={custom} onChange={e => setCustom(e.target.value)} type="number" min="1" placeholder="$" className="w-full mt-1 px-3 py-2 rounded-md bg-white border" style={{ borderColor: 'rgba(13,42,32,0.15)' }} />
          </div>
          <div className="grid md:grid-cols-2 gap-4">
            <div><label className="text-[12px] text-[#0d2a20]/70">Full name *</label><input required value={name} onChange={e => setName(e.target.value)} className="w-full mt-1 px-3 py-2 rounded-md bg-white border" style={{ borderColor: 'rgba(13,42,32,0.15)' }} /></div>
            <div><label className="text-[12px] text-[#0d2a20]/70">Email *</label><input required type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full mt-1 px-3 py-2 rounded-md bg-white border" style={{ borderColor: 'rgba(13,42,32,0.15)' }} /></div>
          </div>
          <button className="inline-flex items-center gap-2 px-5 py-3 rounded-md btn-coral text-[14px]"><Heart size={16} /> Donate ${custom || amt} <ArrowUpRight size={16} /></button>
        </form>
      </section>
    </div>
  );
};

export default Donate;
